import { useTheme } from '@veneer/theme';

/**
 * Hook to control inputs/form controls background.
 * @returns {string} background type
 */
export default function useInputBackground(inputBackgroundProp) {
  var theme = useTheme();
  return inputBackgroundProp || theme.inputBackground;
}